"use strict";

exports.__esModule = true;
exports.default = void 0;
var _arrayPush = _interopRequireDefault(require("./_arrayPush.js"));
var _getPrototype = _interopRequireDefault(require("./_getPrototype.js"));
var _getSymbols = _interopRequireDefault(require("./_getSymbols.js"));
var _stubArray = _interopRequireDefault(require("./stubArray.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? _stubArray.default : function (object) {
  var result = [];
  while (object) {
    (0, _arrayPush.default)(result, (0, _getSymbols.default)(object));
    object = (0, _getPrototype.default)(object);
  }
  return result;
};
var _default = exports.default = getSymbolsIn;